import { useAppSelector } from 'store/hooks';

export const useProductType = () => {
  const productType = useAppSelector((state) => state.global.productType);
  const isCryptoProcessing = productType === 'CryptoProcessing';

  const cpClass = (baseClass: string) =>
    isCryptoProcessing ? {
      [`${baseClass}--crypto-processing`]: true,
    } : {};

  return {
    productType, isCryptoProcessing, cpClass,
  };
};
